import { createRouter, createWebHashHistory } from 'vue-router'
import { preparePasswordLogin } from '@/services/passwordLogin'

import LoginView from '@/views/LoginView.vue'
import LoadingView from '@/views/LoadingView.vue'
import MainView from '@/views/MainView.vue'
import MyHomeView from '@/views/MyHomeView.vue'
import MyHomeAccessesView from '@/views/MyHomeAccessesView.vue'
import MyHomeAccessEditor from '@/views/MyHomeAccessEditor.vue'
import FinanceView from '@/views/FinanceView.vue'
import ProfileSelecting from '@/views/ProfileSelecting.vue'
import BotHelperView from '@/views/BotHelperView.vue'
import NotificationsView from '@/views/NotificationsView.vue'
import SelectPaymentType from '@/views/PaymentProcess/SelectPaymentType.vue'
import TariffList from '@/views/PaymentProcess/TariffList.vue'
import SelectedTariff from '@/views/PaymentProcess/SelectedTariff.vue'
import PaymentPage from '@/views/PaymentProcess/PaymentPage.vue'
import PaymentSuccess from '@/views/PaymentProcess/PaymentSuccess.vue'
import AddBalancePage from '@/views/PaymentProcess/AddBalancePage.vue'
import ContactsPage from '@/views/ContactsPage.vue'
import FingerPrint from '@/views/FingerPrint.vue'
import AllProfilesView from '@/views/ProfilesPages/AllProfilesView.vue'
import DeleteProfileForm from '@/views/ProfilesPages/DeleteProfileForm.vue'
import AddNewAccount from '@/views/ProfilesPages/AddNewAccount.vue'
import SettingsPage from '@/views/SettingsPage.vue'
import ChristmasGift from '@/views/ChristmasGift.vue'
import AdditionalServicesCheck from '@/views/PaymentProcess/AdditionalServicesCheck.vue'

const routes = [
  { path: '/my-home/accesses', name: 'my-home-accesses', component: MyHomeAccessesView },
  { path: '/my-home/faceid', name: 'my-home-faceid', component: MyHomeAccessEditor, props: { kind: 'photos' } },
  { path: '/my-home/car-number', name: 'my-home-car-number', component: MyHomeAccessEditor, props: { kind: 'vehicles' } },
  {
    path: '/my-home',
    name: 'my-home',
    component: MyHomeView
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/loading',
    name: 'loading',
    component: LoadingView
  },
  {
    path: '/main',
    name: 'main',
    component: MainView
  },
  {
    path: '/finance',
    name: 'finance',
    component: FinanceView
  },
  {
    path: '/profiles-selecting',
    name: 'profiles-selecting',
    component: ProfileSelecting
  },
  {
    path: '/bot',
    name: 'bot',
    component: BotHelperView
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsView
  },
  {
    path: '/payment-type',
    name: 'payment-type',
    component: SelectPaymentType
  },
  {
    path: '/tariff-list',
    name: 'tariff-list',
    component: TariffList
  },
  {
    path: '/selected-tariff',
    name: 'selected-tariff',
    component: SelectedTariff
  },
  {
    path: '/payment-process',
    name: 'payment-process',
    component: PaymentPage
  },
  {
    path: '/payment-success',
    name: 'payment-success',
    component: PaymentSuccess
  },
  {
    path: '/add-to-balance',
    name: 'add-to-balance',
    component: AddBalancePage
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactsPage
  },
  {
    path: '/fingerprint',
    name: 'fingerprint',
    component: FingerPrint
  },
  {
    path: '/profiles',
    name: 'profiles',
    component: AllProfilesView
  },
  {
    path: '/delete-profile',
    name: 'delete-profile',
    component: DeleteProfileForm
  },
  {
    path: '/add-new-account',
    name: 'add-new-account',
    component: AddNewAccount
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsPage
  },
  {
    path: '/christmas-gift',
    name: 'christmas-gift',
    component: ChristmasGift
  },
  {
    path: '/additional-services-check',
    name: 'additional-services-check',
    component: AdditionalServicesCheck
  }
]

preparePasswordLogin()

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
